module.exports = __webpack_public_path__ + "img/foot-scanner-icon.2288aee2.svg";